/* unplugin-vue-components disabled */import { render } from "./CategoryDetails.vue?vue&type=template&id=17a09a4a&scoped=true"
import script from "./CategoryDetails.vue?vue&type=script&lang=js"
export * from "./CategoryDetails.vue?vue&type=script&lang=js"

import "./CategoryDetails.vue?vue&type=style&index=0&id=17a09a4a&lang=less&scoped=true"

import exportComponent from "E:\\Jweb\\结课作业\\KilaKila-Blog\\kilakila-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17a09a4a"]])

export default __exports__